import Input from './text-input-mask';

export { default as MaskService } from './mask-service';
export { default as TextInputMask } from './text-input-mask';

export default Input;
